import Link from "next/link"
import Button from "../General/Button"

function HowItWorks() {
    return (
        <div id="how-it-works" className='--align py-10 lg:py-[60px]'>
            <h1 className='text-center text-[#13203E] text-[40px] font-[650] mb-[34px] lg:text-[52px]'>How It Works ?</h1>

            <div className="md:flex md:justify-between md:items-center">
                <div className='md:w-[50%] lg:w-[52%]'>
                    <img className='w-full md:w-full' src="/Home/HowItWorks.svg" alt="QuickDelivery" loading='lazy'/>
                </div>

                <div className='mt-[20px] md:w-[40%] lg:w-[40%] relative'>
                    <h5 className='text-dark-saffron text-[24px] font-semibold lg:text-[36px] font-[600] relative z-[10]'>Spot Buying</h5>

                    <p className='text-[#333333] font-[300] lg:font-[200] text-[14px] mt-3 lg:text-[20px]'>
                        View the latest spot prices effortlessly, in real-time, on your screen! We will handle the logistics, 
                        financing, and fulfillment for you. Buy what you need, when you need it, and we'll take care of the rest. 
                        We'll source the best prices, negotiate with sellers, and proactively plan our procurement process so
                        you can relax!
                    </p>
                    
                    <Link href={'/spot-buying'} className='w-[48%] lg:w-[193px] block mt-[32px]'>
                        <Button styles = "text-white bg-theme-orange w-full h-[42px] lg:h-[54px] font-[500] lg:text-[18px]">
                            Open Spot Prices
                        </Button>
                    </Link>

                    <img className="absolute -top-[45px] w-[98px] lg:w-[137px] h-[98px] lg:h-[137px] lg:-top-[66px] lg:-left-[120px] z-1" src="/Home/Ellipse.svg" alt="" loading='lazy' />
                </div>
            </div>

        </div>
    )
}

export default HowItWorks